<template>
    <div class="project-task">
        <el-row :gutter="5" >
            <el-col :span="8" v-loading="leftLoading">
                <div class="left" >
                    <div class="top flex-between">
                        <el-button type="primary" size="small" @click="addTask">{{$lange == 'en' ? 'Add level 1 task' : '新增一级任务'}}</el-button>
                    </div>
                    <div class="content">
                        <div class="title flex-between">
                            <p>{{$lange == 'en' ? 'Level 1 task' : '一级任务'}}</p>
                            <p>{{$lange == 'en' ? 'Operation' : '操作'}}</p>
                        </div>
                        <div class="lists">
                            <el-radio-group v-model="radioValue" style="width: 100%" @change="getChildTask">
                                <template v-for="(item, index) in taskData">
                                    <div class="list flex-between" v-if="item.isCreate" >
                                        <el-radio :label="0" disabled="true" title="未创建,不可选择">
                                            <el-input v-model.number="item.sort" size="mini" style="width: 50px;"></el-input>
                                            <el-input v-model="item.tasksName" size="mini"></el-input>
                                            <!--                                        <input type="text" v-model="item.taskName" @keydown="saveTask(item)">-->
                                        </el-radio>
                                        <div class="btn-group">
                                            <el-button type="text" style="color: #bbbbbb" @click="saveTask(item, index)">{{$lange == 'en' ? 'Save' : '保存'}}</el-button>
                                            <el-button type="text" style="color: #bbbbbb" @click="cancelAddTask(index)">{{$lange == 'en' ? 'Cancel' : '取消'}}</el-button>
                                        </div>
                                    </div>
                                    <div class="list flex-between break-word" v-else>
                                        <el-radio :label="item.id" :title="item.tasksName" class="" style="flex: 0 55%;max-width: 300px;">({{item.sort}}){{item.tasksName}}</el-radio>
                                        <div class="btn-group">
                                            <el-button type="text" style="color: #bbbbbb" @click="editTask(item)">{{$lange == 'en' ? 'Edit' : '编辑'}}
                                            </el-button>
                                            <el-button type="text" style="color: #bbbbbb" @click="deleteTask(item,index)">{{$lange == 'en' ? 'Delete' : '删除'}}</el-button>
                                        </div>
                                    </div>
                                </template>

                            </el-radio-group>

                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12" v-loading="rightLoading">
                <div class="right" >
                    <div class="top flex-between">
                        <div class="search-box " >
                            <p class="flex-between" style="justify-content: flex-start;">
                                <span :title="childTitle" style="text-align: left;">{{childTitle}}</span>
<!--                                <span style="width: 65px">-{{$lange == 'en' ? 'Task list' : '任务列表'}}</span>-->
                            </p>
                            <div class="flex-between" style="margin-top: 20px">
                                <cc-constant-selector style="display:inline-block;"
                                                      type="select"
                                                      valType="String"
                                                      placeholder="请选择状态"
                                                      v-model="searchParams.productLine"
                                                      code="productLine"
                                                      api="admin/dict/pageTree"
                                />
                                <el-input placeholder="请输入任务关键字" size="mini" v-model="searchParams.tasksName"
                                          style="display:inline-block;width: 160px"></el-input>
                                <el-button type="primary" size="mini" @click="getChildTask">{{$lange == 'en' ? 'Search' : '搜索'}}</el-button>
                                <el-button type="primary" size="mini" @click="addTask(true)">{{$lange == 'en' ? 'Add level 2 task' : '新增二级任务'}}</el-button>
                            </div>

                        </div>
                    </div>
                    <div class="content right-cotent">
                        <div class="title flex-between">
                            <p class="max-flex">{{$lange == 'en' ? 'Task content' : '任务内容'}}</p>
                            <p>{{$lange == 'en' ? 'Estimated working hours' : '预计工时'}}</p>
                            <p style="flex: 0 40%">{{$lange == 'en' ? 'Product line' : '适合产线'}}</p>
                            <p>{{$lange == 'en' ? 'Operation' : '操作'}}</p>
                        </div>
                        <div class="lists">
                            <template v-for="(item, index) in taskChildData">
                                <div class="list flex-between" v-if="item.isCreate">
                                    <div class="flex-between max-flex">
                                        <el-input style="max-width: 50px;display: inline-block;" size="mini" v-model.number="item.sort" ></el-input>
                                        <el-input v-model="item.tasksName"  size="mini"></el-input>
                                    </div>
                                    <div>
                                        <el-input style="width: 50px"  size="mini" v-model.number="item.workHour"></el-input>
                                    </div>
                                    <div style="flex: 0 40%">
                                        <el-checkbox-group v-model="item.productLine" style="width: 100%" >
                                            <template v-for="line in productLineLists.children">
                                                <el-checkbox  :label="line.code"></el-checkbox>
                                            </template>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="btn-group">
                                        <el-button type="text" style="color: #bbbbbb" @click="saveChildTask(item, index)">{{$lange == 'en' ? 'Save' : '保存'}}</el-button>
                                        <el-button type="text" style="color: #bbbbbb" @click="cancelAddTask(index, true)">{{$lange == 'en' ? 'Cancel' : '取消'}}</el-button>
                                    </div>
                                </div>
                                <div class="list flex-between" v-else>
                                    <p class="max-flex" style="text-align: left;">({{item.sort}}){{item.tasksName}} </p>
                                    <div>{{item.workHour || 0}}</div>
<!--                                    <div>-->
<!--                                        <template v-for="line in productLineLists.children">-->
<!--                                            <span style="margin-right: 15px">{{line.code}}</span>-->
<!--                                        </template>-->
<!--                                    </div>-->
                                    <div style="flex: 0 40%">
                                        <el-checkbox-group v-model="item.productLine" style="width: 100%; text-align: left;" >
                                            <template v-for="line in productLineLists.children">
                                                <el-checkbox  :label="line.code" disabled > </el-checkbox>
                                            </template>
                                        </el-checkbox-group>
                                    </div>

                                    <div class="btn-group">
                                        <el-button type="text" style="color: #bbbbbb" @click="item.isCreate = true">{{$lange == 'en' ? 'Edit' : '编辑'}}</el-button>
                                        <el-button type="text" style="color: #bbbbbb" @click="deleteTask(item, index, true)">{{$lange == 'en' ? 'Delete' : '删除'}}</el-button>
                                    </div>
                                </div>


                            </template>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>


    </div>
</template>

<script>
    export default {
        name: "ProjectTask",
        data() {
            return {
                leftLoading: false,
                rightLoading: false,
                radioValue: 0,
                taskData: [],
                taskChildData: [],
                parentId: 0,
                searchParams: {
                    productLine: "",
                    tasksName: ""
                },
                checkList: [],
                productLineLists: [],
                childTitle: ""
            }
        },
        methods: {
            deleteTask(item,ind, childTask = false){
                this.$confirm('此操作会删除该任务, 是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        id: item.id
                    }
                    this.ccRequest.do("admin/fsb/job/delete", data, "GET").then(res => {
                        this.$message({
                            type: 'success',
                            message: '任务已删除'
                        });
                        this.getParentTask();
                        // 已经刷新了，前端就不需要做兼容了
                        // if(childTask){
                        //     this.taskChildData.splice(ind, 1);
                        //     return false;
                        // }
                        // this.taskData.splice(ind, 1);
                    }).catch(res => {
                        return this.$message({
                            type: "error",
                            message: res.response.data.message

                        })
                    })


                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            },
            saveChildTask(item, ind){
                let data = item;
                data.parentId = this.radioValue;
                if (data.tasksName.length < 1) {
                    this.$message({
                        type: "warning",
                        message: "请输入任务名称"
                    })
                    return false;
                }
                this.ccRequest.do("admin/fsb/job/save", data, "POSTJSON").then(res => {
                    this.$message({
                        type: "success",
                        message: "操作成功"
                    })
                    this.getChildTask();
                })
            },
            getProductLines() {
                this.ccRequest.do("admin/dict/pageTree", {code: "productLine"}, "GET").then(res => {
                    console.log(res, "asaaaa")
                    this.productLineLists = res.rows[0];
                })
            },
            editTask(item) {
                console.log(item);
                item.isCreate = true;
            },
            saveTask(item, ind) {
                let data = item;
                if (data.tasksName.length < 1) {
                    this.$message({
                        type: "warning",
                        message: "请输入任务名称"
                    })
                    return false;
                }
                if (data.tasksName.length > 50) {
                    this.$message({
                        type: "warning",
                        message: "任务名称长度过长"
                    })
                    return false;
                }
                if(data.sort%1 !== 0 || data.sort < 1){
                    this.$message({
                        type: "warning",
                        message: "排序请输入正整数"
                    })
                    return false;
                }
                data.parentId = 0;
                this.ccRequest.do("admin/fsb/job/save", data, "POSTJSON").then(res => {
                    this.$message({
                        type: "success",
                        message: "操作成功"
                    })
                    this.getParentTask();
                })
            },
            cancelAddTask(ind,childTask = false) {
                if(childTask){
                    // console.log(this.taskChildData[ind])
                    if(this.taskChildData[ind].id != undefined){
                        this.getChildTask();
                        this.taskChildData[ind].isCreate = false;
                        return false;
                    }
                    this.taskChildData.splice(ind, 1);
                }
                if(this.taskData[ind].id != undefined){
                    // console.log(this.taskData[ind])
                    this.getParentTask();
                    this.taskData[ind].isCreate = false;
                    return false;
                }
                this.taskData.splice(ind, 1);

            },
            addTask(childTask = false) {

                if(childTask === true){
                    let newData = {
                        tasksName: "",
                        workHour: 0,
                        productLine: [],
                        isCreate: true
                    };
                    for(let j in this.productLineLists.children){

                        newData.productLine.push(this.productLineLists.children[j].code);
                    }
                    for(let i in this.taskChildData){
                        if(this.taskChildData[i].tasksName.length< 1){
                            this.$message({
                                type: "warning",
                                message: "已有新建的任务, 请先保存"
                            })
                            return false;

                        }
                    }
                    this.taskChildData.unshift(newData)
                    return false;
                }
                for(let i in this.taskData){
                    if(this.taskData[i].tasksName.length< 1){
                        this.$message({
                            type: "warning",
                            message: "已有新建的任务, 请先保存"
                        })
                        return false;

                    }
                }
                this.taskData.unshift({
                    tasksName: "",
                    workHour: 0,
                    productLine: "",
                    isCreate: true
                })
            },

            getParentTask() {

                this.leftLoading = true;
                this.ccRequest.do("admin/fsb/job/query", {parentId: 0, pageSize: 999}, "GET").then(res => {
                    for (let i in res.rows) {
                        res.rows[i].isCreate = false;
                    }
                    this.taskData = res.rows;
                    if (res.rows.length > 0) {
                        this.radioValue = res.rows[0].id;
                        this.getChildTask();
                    }
                    this.leftLoading = false;
                }).catch( res => {
                    this.leftLoading = false;
                    this.$message({
                        type: "warning",
                        message: res.message
                    })
                })
            },
            getChildTask() {
                for(let i in this.taskData){
                    if(this.taskData[i].id === this.radioValue){
                        this.childTitle = this.taskData[i].tasksName
                    }
                }
                this.rightLoading = true;
                let data = this.searchParams;
                // console.log()
                data.parentId = this.radioValue;
                this.ccRequest.do("admin/fsb/job/query", data, "GET").then(res => {
                    for(let i in res.rows){
                        res.rows[i].isCreate = false;
                    }
                    this.taskChildData = res.rows;
                    this.rightLoading = false;
                }).catch( res => {
                    this.rightLoading = false;
                    this.$message({
                        type: "warning",
                        message: res.message
                    })
                })
            },

            getData() {
                this.getParentTask();
                this.getProductLines();

            }
        },
        mounted() {
            this.getData();
        }
    }
</script>
<style lang="scss">

</style>
<style scoped lang="scss">
    .project-task {
        .left, .right {
            background: #ffffff;
            padding: 20px;
        }

        .left {
            .top {
                justify-content: flex-end;
                margin-bottom: 20px;

            }
        }

        .content {

            &.right-cotent{
                margin-top: 23px;
            }
            .title {
                border-top: 1px solid #e4e4e4;
                padding: 20px;
                font-size: 14px;
                font-weight: bolder;
                >*{
                    flex: 0 25%;
                }
                p:last-child {
                    width: 70px;
                    text-align: center;
                }
            }

            .lists {
                /*暂时注释, 看后面优化方案*/
                /*min-height: 50vh;*/
                font-size: 14px;
                .list {
                    border-top: 1px solid #e4e4e4;
                    padding: 10px 20px;
                    >*{
                        flex: 0 25%;
                    }
                }
            }
            .max-flex{
                flex: 0 55% !important;
            }
        }
        .right{
            text-align: center;
        }

        .search-box {
            width: 630px;
            justify-content: flex-start;
            >*{
                margin-right: 15px;
            }
        }
    }
</style>
